import { Layout, AppBar, TitlePortal, defaultTheme, defaultDarkTheme } from 'react-admin';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { deepmerge } from '@mui/utils';
import GroupSelector from '../components/GroupSelector';
import logo from '../images/skylar-cms-logo.png';

const Logo = () => (
	<img src={logo} alt="Skylar CMS Logo" style={{ marginTop: '8px', marginBottom: '8px' }} />
);

export const BrandedAppBar = () => (
	<AppBar>
		<TitlePortal />
	   <Box sx={{ marginLeft: 'auto', marginRight: 2 }}>
			<GroupSelector />
		</Box>
	</AppBar>
);

export const AppLayout = ({ children }) => (
	<Layout appBar={BrandedAppBar}>
		{children}
	</Layout>
);

AppLayout.propTypes = {
	children: PropTypes.any // Array, ReactNode?
};

const appBarHeight = '76px';

const styleOverrides = {
	components: {
		MuiAppBar: {
			styleOverrides: {
				root: {
					backgroundColor: '#1a237e',
					height: appBarHeight
				},
			},
		},
		MuiCssBaseline: {
			styleOverrides: {
				'& .RaLayout-appFrame': {
					marginTop: appBarHeight + ' !important'
				},
			},
		},
	},
};

export const appTheme = deepmerge( defaultTheme, styleOverrides );
export const appDarkTheme = deepmerge( deepmerge( defaultDarkTheme, styleOverrides ), { palette: { mode: 'dark' } });

export default AppLayout;